import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  selectors as authSel
} from '../redux/auth/index';

const mapStateToProps = (state) => ({
  user: authSel.user(state)
});

const mapDispatchToProps = (dispatch) => ({});

const readOnly = 'toolkit_readonly';
const user = 'toolkit_user';
const superAdmin = 'toolkit_super_admin';
const admin = 'toolkit_admin';

export class Role {
  static get user() {
    return user;
  }

  static get readOnly() {
    return readOnly;
  }

  static get superAdmin() {
    return superAdmin;
  }

  static get admin() {
    return admin;
  }
}

export function setupAccess(allowed, denied = [], attribute='role') {
  return (WrappedComponent) => {
    return connect(
      mapStateToProps,
      mapDispatchToProps
    )(
      class HOCAccessControl extends React.Component {
        render() {
          //
          let xor = (a,b) => {
            return ( a || b ) && !( a && b );
          };

          const userAttribute = this.props.user[attribute];

          const isAllowed = allowed.indexOf(userAttribute) >= 0;
          const isDenied = denied.indexOf(userAttribute) >= 0;


          const component = this.props.user && ( isAllowed ? !isDenied : !isDenied) ?
            <WrappedComponent {...this.props} /> : <div>access denied!</div>;

          return (
            <div>
              {component}
            </div>
          );
        }
      }
    )
  }
}

const allRoles = [readOnly, user, superAdmin, admin];

@connect(
  mapStateToProps,
  mapDispatchToProps
)
class RestrictAccess extends React.Component {
  render() {
    if (this.props.user && this.props.allowed.indexOf(this.props.user.role) >= 0 &&
      this.props.denied.indexOf(this.props.user.role) < 0) {
      return this.props.children;
    } else if (this.props.showAccessDenied) {
      return (
        <div>
          access denied!
        </div>
      );
    } else
      return null;
  }
}

RestrictAccess.propTypes = {
  allowed: PropTypes.arrayOf(
    function (propValue, key, componentName, location, propFullName) {
      if (allRoles.indexOf(propValue[key]) < 0) {
        return new Error(
          'Invalid prop `' + propFullName + '` supplied to' +
          ' `' + componentName + '`. Validation failed.'
        );
      }
    }
  ).isRequired,
  denied: PropTypes.arrayOf(
    function (propValue, key, componentName, location, propFullName) {
      if (allRoles.indexOf(propValue[key]) < 0) {
        return new Error(
          'Invalid prop `' + propFullName + '` supplied to' +
          ' `' + componentName + '`. Validation failed.'
        );
      }
    }
  ),
  showAccessDenied: PropTypes.bool
};

RestrictAccess.defaultProps = {
  denied: [],
  showAccessDenied: false
};

export default RestrictAccess;



// WEBPACK FOOTER //
// ./src/util/common/access_control.js